import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement("path", {
  d: "M14 7l-5 5 5 5V7z"
}), 'ArrowLeft');